<div fxLayout="column" fxLayoutAlign="stretch">
  @if (isGuest) {
    <button
      aria-label="Login"
      class="btn btn-primary"
      title="Login"
      type="button"
      (click)="login()"
    >
      Login
    </button>
  } @else {
    @if (item?.hasAccount) {
      @if (item?.isCheckedOut) {
        <button
          aria-label="Early Return Hoopla"
          class="btn btn-primary"
          title="Early Return"
          type="button"
          (click)="earlyReturn()"
        >
          Early Return
        </button>
        <button
          role="button"
          type="button"
          aria-label="'Get' format"
          class="btn btn-primary"
          (click)="goToHooplaFulfillment()"
        >
          Get {{ format }}
        </button>
      } @else {
        @if (showCheckOut) {
          <button
            aria-label="Checkout"
            class="btn btn-primary"
            title="Checkout"
            type="button"
            (click)="checkout()"
            [disabled]="disableCheckout"
            [ngClass]="{ 'greyed-out': disableCheckout }"
          >
            Checkout
          </button>
        }
        @if (showCancelHold) {
          <button
            aria-label="Cancel Hold"
            class="btn btn-primary"
            title="Cancel Hold"
            type="button"
            (click)="cancelHold()"
          >
            Cancel Hold
          </button>
        }
      }
      @if (showPlaceHold) {
        <button
          aria-label="Place Hold"
          class="btn btn-primary"
          title="Place Hold"
          type="button"
          (click)="placeHold()"
        >
          Place Hold
        </button>
      }
    } @else {
      @if (item) {
        <button
          role="button"
          type="button"
          aria-label="Create Hoopla Account"
          class="btn btn-primary"
          (click)="goToHoopla()"
        >
          Create Hoopla Account
        </button>
      }
    }
  }
</div>
